module.exports = __webpack_public_path__ + "static/media/Asset 47.462c9548.png";